import { SupportedTagEntities, SupportedTagEntityTypes } from '../../../../store/Tags';
// Not the Tagging barrel: it also exports TagsTable, dragging an admin grid into every tags cell.
import { Tags } from '../../Tagging/Tags';
import type { TagEntityRefresh } from '../../Tagging/Tags';

export type EntityTagRendererProps = {
  entity: SupportedTagEntities;
  entityType: SupportedTagEntityTypes;
  fetchFn: TagEntityRefresh;
  entityId: string;
  entityAccountId?: string;
  readOnly?: boolean;
};

export function EntityTagRenderer({
  entity,
  entityType,
  fetchFn,
  entityId,
  entityAccountId,
  readOnly
}: EntityTagRendererProps) {
  return (
    <div className="py-1 h-full w-full">
      <Tags
        entity={entity}
        entityId={entityId}
        entityAccountId={entityAccountId}
        entityType={entityType}
        entityFetchFn={fetchFn}
        readOnly={readOnly}
        isGrid={true}
      />
    </div>
  );
}
